import { Component, Input } from '@angular/core';
import DOMPurify from 'dompurify';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'crm-activity-rich-text',
  template: `<span class="rte-value" [innerHTML]="sanitizedRichText | iTrustThisHtml"></span>`,
  styleUrls: ['activity-rich-text.component.scss'],
  imports: [CommonModule, GalaxyPipesModule],
})
export class ActivityRichTextComponent {
  sanitizedRichText = '';

  @Input({ required: true }) set richText(rteValue: string) {
    const cleanedText = rteValue
      // Remove empty paragraphs
      .replace(/<p>&nbsp;<\/p>/g, '')
      // Replace &nbsp; with normal spaces
      .replace(/&nbsp;/g, ' ')
      // Only replace newlines that are not part of block-level elements
      .replace(/(?<!<\/p>)\n(?!<p>)/g, '<br>');

    this.sanitizedRichText = DOMPurify.sanitize(cleanedText);
  }
}
